/* eslint-disable max-len */
import React, {useEffect, useState} from 'react'

import PdfRender from './PdfRender.js'
import ImageRender from './ImageRender.js'

import {Icon} from '@lazarusai/forms-ui-components'

import '../styles/View.css'

export default function View(props) {
  const [fileType, setFileType] = useState(null) // string to be added to wrapper div to help delineate with css if needed
  const [fileDrag, setFileDrag] = useState(false)
  const [moveInput, setMoveInput] = useState(false)

  function dragEnter(e) {
    e.preventDefault()
    setFileDrag(true)
    setMoveInput(true)
  }

  function dragDrop(e) {
    e.preventDefault()
    // e.target.value = null
    e.stopPropagation()
    setFileDrag(false);
    setMoveInput(false);
    props.onChangeFile(e)
  }

  function dragLeave(e) {
    e.preventDefault()
    setFileDrag(false)
    setMoveInput(false);
  }

  function dragOver(e) {
    e.preventDefault()
    e.stopPropagation()
    setFileDrag(true)
  }

  useEffect(() => {
    if (props.file) {
      setFileType(props.file?.type ? (props.file.type === 'application/pdf' ? 'pdf' : 'image') : null)
    }
  }, [props.file])


  // const fileIndex = 0 // file index placeholder

  return (
    <div className='view-container'>
      <div className='title-container'>
        <Icon
          icon={'book-outline'}
          key='doc-icon'
          fill='var(--colors-brand-light-blue)'
        />
        <h3 className='section-title'>Document</h3>
      </div>
      <div className={`full-doc-view${fileDrag ? ' border-highlight' : ''}${fileType ? ` ${fileType}` : ''}`}>
        <label
          htmlFor="file-wrapper-label"
          onDragEnter={dragEnter}
          onDrop={dragDrop}
          onDragLeave={dragLeave}
          onDragOver={dragOver}
        >
          {fileType === 'pdf' ?
            <PdfRender file={props.file} /> :
            <ImageRender file={props.file} />
          }
        </label>
        <input
          type="file"
          id="file-wrapper-label"
          style={{zIndex: moveInput ? '5' : '-1'}}
          accept='.png, .jpg, .jpeg, .tiff, .tif, application/pdf'
          onChange={props.onChangeFile}
          onDrop={dragDrop}
          onDragLeave={dragLeave}
        />
      </div>
    </div>
  )
}
